import React, {useEffect, useState} from 'react';
import DataGrid, {Column, Editing, Label} from "devextreme-react/data-grid";
import IPromotion from "../../models/IPromotion";
import IGestionReservation from "../../models/IGestionReservation";
import useApi from "../../hooks/useApi";
import {Popup} from "devextreme-react/popup";
import IPromotionApplicable, {IPromotionApplicableSel} from "../../models/IPromotionApplicable";

export interface IPopupPromotionProps {
    reservation: IGestionReservation;
    onClose: (promotionApplicableSel: IPromotionApplicableSel[]) => void;
}

const PopupPromotion = ({reservation, onClose}: IPopupPromotionProps) => {
    const [promotionsApplicable, setPromotionsApplicable] = useState<IPromotionApplicableSel[]>([])
    const {postData} = useApi<IPromotionApplicable[]>("promotion");

    useEffect(() => {
        const abortControllert = new AbortController();
        postData(reservation, "promotion/getPromotionApplicable", true, abortControllert.signal).then(result => {
            if (result) {
                const pomotions = [
                    ...result.map(r => ({...r, selectionne: reservation?.promotionAppliquees?.some(s => s?.idPromotion.equals(r?.idPromotion))}))]
                setPromotionsApplicable(pomotions);
                if (result.length === 0) onClose([]);
            }
        })
        return () => abortControllert.abort();
    }, []);

    return (<Popup
            onHiding={() => onClose(promotionsApplicable)}
            visible={true}
            dragEnabled={true}
            resizeEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            dragOutsideBoundary={true}
            title="Promtions applicables"
            width={450}
            height={"180"}>
            <div>
                <DataGrid dataSource={promotionsApplicable}>
                    <Editing allowUpdating={true} mode={"cell"}/>
                    <Column dataField={"description"} allowEditing={false}/>
                    <Column dataField={"montantApplicable"} allowEditing={false} format={"#.00"}/>
                    <Column dataField={"selectionne"} width={80} caption={""} dataType={"boolean"}/>
                </DataGrid>
            </div>
        </Popup>
    );
};

export default PopupPromotion;